import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetInsuranceCompanies() {
  return useQuery(queries.patients.listInsuranceCompanies({sort: {field: 'name', dir: 'asc'}}))
}
